import React from 'react';

import { IconButton, SidePage, PlaylistAddCheckIcon } from '@gogame/components';

import { LEFT_DRAWER_Z_INDEX } from '../Sidebar/constants';
import NotificationsList from './NotificationsList';
import { useIsUpdating, useLoadNotifications } from './data';

export const Notifications = ({
  onClose,
  open,
  onExited,
  onReadMessage,
  onReadAllMessages,
}) => {
  const { data, isLoading, isRefetching } = useLoadNotifications();
  const isUpdating = useIsUpdating();
  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      fetching={isRefetching || isUpdating}
      size={'m'}
      backdrop={false}
      direction={'right'}
      directionOfset={'64px'}
      zIndex={LEFT_DRAWER_Z_INDEX}
    >
      <SidePage.Title
        onClose={onClose}
        title={'Notifications'}
        actions={
          <IconButton
            icon={<PlaylistAddCheckIcon />}
            onClick={onReadAllMessages}
            tooltip={'Mark all as read'}
          />
        }
      />
      <SidePage.Content disableGutters={true} disableScroll={true}>
        <NotificationsList data={data} onReadMessage={onReadMessage} />
      </SidePage.Content>
    </SidePage>
  );
};
